/* =====================================================================
   Ivy Row — Homepage: "In real life" sections (UGC agent)
   wh-ugc  : customer videos played muted only when on-screen; accessible
             full-screen viewer (modal dialog, Escape, close button, backdrop
             click, arrows, swipe, focus restored).
   wh-look : dots on the photo (bubbles), cross-hover between board / list,
             "Choose size" label restored after an add (wise.js).
   Depends on wh-core.js (window.WH). ES5, no modules, idempotent.
   ===================================================================== */
(function () {
  'use strict';

  var WH = window.WH;
  if (!WH) return;

  var nav = window.navigator || {};
  var saveData = !!(nav.connection && nav.connection.saveData);
  var canHover = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);

  function up(el, selector) {
    return el && el.nodeType === 1 && typeof el.closest === 'function' ? el.closest(selector) : null;
  }

  function norm(text) {
    return String(text || '').replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '');
  }

  function focusEl(el) {
    if (!el || typeof el.focus !== 'function') return;
    try {
      el.focus({ preventScroll: true });
    } catch (err) {
      el.focus();
    }
  }

  function attemptPlay(video) {
    try {
      video.muted = true;
      var p = video.play();
      if (p && typeof p['catch'] === 'function') p['catch'](function () {});
    } catch (err) {
      /* playback refused: the poster image stays visible */
    }
  }

  function empty(el) {
    if (!el) return;
    while (el.firstChild) el.removeChild(el.firstChild);
  }

  /* ================= Customer photos ================= */
  function initUgc(root) {
    if (root.__whUgc) return;

    var dialog = root.querySelector('[data-wh-ugc-dialog]');
    var openers = WH.all('[data-wh-ugc-open]', root);
    var videos = WH.all('.wh-ugc__vid', root);
    var stops = [];
    var viewerOpen = false;
    var current = -1;
    var lastOpener = null;
    var prevOverflow = '';
    var touch = null;

    /* ----- Wall videos: muted loop playback, only when on-screen ----- */
    function autoplayAllowed() {
      return root.hasAttribute('data-wh-ugc-autoplay') && !WH.reduced && !saveData && !document.hidden;
    }

    function wallPlay(video) {
      if (!video.getAttribute('src')) {
        var src = video.getAttribute('data-src');
        if (!src) return;
        video.setAttribute('src', src);
      }
      attemptPlay(video);
    }

    function wallPause(video) {
      if (!video.paused) video.pause();
    }

    function pauseWall() {
      videos.forEach(wallPause);
    }

    function resumeWall() {
      if (viewerOpen || !autoplayAllowed()) return;
      videos.forEach(function (video) {
        if (video.__whUgcIn) wallPlay(video);
      });
    }

    function onPlaying(e) {
      e.target.classList.add('is-on');
    }

    videos.forEach(function (video) {
      video.addEventListener('playing', onPlaying);
      var tile = up(video, '.wh-ugc__tile') || video;
      stops.push(WH.inView(tile, function () {
        video.__whUgcIn = true;
        if (!viewerOpen && autoplayAllowed()) wallPlay(video);
      }, function () {
        video.__whUgcIn = false;
        wallPause(video);
      }, { threshold: 0.6 }));
    });

    var offReduced = WH.onReduced(function (reduced) {
      if (reduced) pauseWall();
      else resumeWall();
    });

    function onVisibility() {
      if (document.hidden) pauseWall();
      else resumeWall();
    }

    document.addEventListener('visibilitychange', onVisibility);

    /* ----- Viewer ----- */
    var stage = dialog ? dialog.querySelector('[data-wh-ugc-stage]') : null;
    var detail = dialog ? dialog.querySelector('[data-wh-ugc-detail]') : null;
    var counter = dialog ? dialog.querySelector('[data-wh-ugc-count]') : null;
    var btnPrev = dialog ? dialog.querySelector('[data-wh-ugc-prev]') : null;
    var btnNext = dialog ? dialog.querySelector('[data-wh-ugc-next]') : null;
    var btnClose = dialog ? dialog.querySelector('[data-wh-ugc-close]') : null;
    var total = openers.length;
    var modal = !!(dialog && typeof dialog.showModal === 'function');

    if (total < 2) {
      if (btnPrev) btnPrev.hidden = true;
      if (btnNext) btnNext.hidden = true;
    }

    function stopStage() {
      if (!stage) return;
      WH.all('video', stage).forEach(function (video) {
        try {
          video.pause();
        } catch (err) {
          /* nothing to stop */
        }
      });
    }

    function setCount(n) {
      if (!counter) return;
      empty(counter);
      var visible = document.createElement('span');
      visible.setAttribute('aria-hidden', 'true');
      visible.textContent = (n + 1) + ' / ' + total;
      var spoken = document.createElement('span');
      spoken.className = 'wh-vh';
      spoken.textContent = 'Item ' + (n + 1) + ' of ' + total;
      counter.appendChild(visible);
      counter.appendChild(spoken);
    }

    /* Show item at index (wraps at edges); dir: -1, 0 or 1 for animation direction */
    function show(index, dir) {
      if (!dialog || !stage || !total) return;
      var n = ((index % total) + total) % total;
      var item = up(openers[n], '.wh-ugc__item');
      var tpl = item ? item.querySelector('template[data-wh-ugc-tpl]') : null;
      if (!tpl || !tpl.content) return;
      var focusInside = dialog.contains(document.activeElement);
      stopStage();
      var frag = tpl.content.cloneNode(true);
      var fig = frag.querySelector('[data-wh-ugc-fig]');
      var info = frag.querySelector('[data-wh-ugc-info]');
      empty(stage);
      empty(detail);
      if (fig) {
        fig.style.setProperty('--wh-ugc-dir', String(dir || 0));
        stage.appendChild(fig);
      }
      if (info && detail) detail.appendChild(info);
      current = n;
      setCount(n);
      var video = stage.querySelector('video');
      if (video && !WH.reduced) attemptPlay(video);
      if (focusInside && !dialog.contains(document.activeElement)) focusEl(btnClose);
    }

    function lock() {
      var de = document.documentElement;
      prevOverflow = de.style.overflow;
      de.style.overflow = 'hidden';
    }

    function unlock() {
      document.documentElement.style.overflow = prevOverflow;
    }

    function open(index, opener) {
      if (!dialog || !stage) return;
      if (viewerOpen) {
        show(index, 0);
        return;
      }
      lastOpener = opener || null;
      viewerOpen = true;
      pauseWall();
      show(index, 0);
      lock();
      var shown = false;
      if (modal) {
        try {
          if (!dialog.open) dialog.showModal();
          shown = true;
        } catch (err) {
          shown = false;
        }
      }
      if (!shown) dialog.setAttribute('open', '');
      focusEl(btnClose);
    }

    /* Common cleanup for all close paths (button, Escape, backdrop, editor) */
    function finish() {
      if (!viewerOpen) return;
      viewerOpen = false;
      stopStage();
      empty(stage);
      empty(detail);
      unlock();
      if (lastOpener && document.documentElement.contains(lastOpener)) focusEl(lastOpener);
      lastOpener = null;
      resumeWall();
    }

    function close() {
      if (!dialog) return;
      if (modal && dialog.open && typeof dialog.close === 'function') {
        dialog.close(); /* the \"close\" event calls finish() */
      } else {
        dialog.removeAttribute('open');
        finish();
      }
    }

    function onOpenerClick(e) {
      var i = openers.indexOf(e.currentTarget);
      if (i > -1) open(i, e.currentTarget);
    }

    function onPrev() {
      if (total > 1) show(current - 1, -1);
    }

    function onNext() {
      if (total > 1) show(current + 1, 1);
    }

    function onDialogClick(e) {
      var t = e.target;
      if (t === dialog || (t && t.nodeType === 1 && t.hasAttribute('data-wh-ugc-dismiss'))) close();
    }

    function onDialogKey(e) {
      var key = e.key;
      if (key === 'Escape' || key === 'Esc') {
        if (!modal || !dialog.open) {
          e.preventDefault();
          close();
        }
        return;
      }
      if (e.target && e.target.tagName === 'VIDEO') return;
      if (key === 'ArrowRight' || key === 'Right') {
        e.preventDefault();
        onNext();
      } else if (key === 'ArrowLeft' || key === 'Left') {
        e.preventDefault();
        onPrev();
      }
    }

    /* Horizontal swipe (mobile); the video control bar remains usable */
    function onTouchStart(e) {
      touch = null;
      if (!e.touches || e.touches.length !== 1) return;
      var t = e.touches[0];
      var target = e.target;
      if (target && target.tagName === 'VIDEO') {
        var rect = target.getBoundingClientRect();
        if (t.clientY > rect.bottom - 72) return;
      }
      touch = { x: t.clientX, y: t.clientY };
    }

    function onTouchEnd(e) {
      var start = touch;
      touch = null;
      if (!start || !e.changedTouches || !e.changedTouches.length) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - start.x;
      var dy = t.clientY - start.y;
      if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.3) {
        if (dx < 0) onNext();
        else onPrev();
      }
    }

    openers.forEach(function (btn) {
      btn.addEventListener('click', onOpenerClick);
    });

    if (btnPrev) btnPrev.addEventListener('click', onPrev);
    if (btnNext) btnNext.addEventListener('click', onNext);
    if (btnClose) btnClose.addEventListener('click', close);

    if (dialog) {
      dialog.addEventListener('close', finish);
      dialog.addEventListener('click', onDialogClick);
      dialog.addEventListener('keydown', onDialogKey);
    }

    if (stage) {
      stage.addEventListener('touchstart', onTouchStart, { passive: true });
      stage.addEventListener('touchend', onTouchEnd, { passive: true });
    }

    root.__whUgc = {
      open: function (index) {
        open(index || 0, null);
      },
      close: close,
      destroy: function () {
        stops.forEach(function (stop) {
          stop();
        });
        offReduced();
        document.removeEventListener('visibilitychange', onVisibility);
        if (viewerOpen) {
          if (modal && dialog.open) {
            try {
              dialog.close();
            } catch (err) {
              /* already closed */
            }
          }
          finish();
        }
        pauseWall();
        root.__whUgc = null;
      }
    };
  }

  /* ================= The look ================= */
  function initLook(root, fromEditor) {
    if (root.__whLook) return;

    var dots = WH.all('[data-wh-look-dot]', root);
    var keyed = WH.all('[data-wh-look-key]', root);
    var observers = [];
    var openDot = null;

    function highlight(key) {
      keyed.forEach(function (el) {
        el.classList.toggle('is-hl', key !== null && el.getAttribute('data-wh-look-key') === key);
      });
    }

    function bubbleOf(dot) {
      var id = dot.getAttribute('aria-controls');
      return id ? document.getElementById(id) : null;
    }

    function setDot(dot, on) {
      var bubble = bubbleOf(dot);
      dot.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (bubble) bubble.hidden = !on;
      if (on) {
        openDot = dot;
        highlight(dot.getAttribute('data-wh-look-key'));
      } else if (openDot === dot) {
        openDot = null;
        highlight(null);
      }
    }

    function closeDot(focusBack) {
      if (!openDot) return;
      var dot = openDot;
      setDot(dot, false);
      if (focusBack) focusEl(dot);
    }

    function onDotClick(e) {
      var dot = e.currentTarget;
      var wasOpen = openDot === dot;
      closeDot(false);
      if (!wasOpen) setDot(dot, true);
    }

    function onCloseClick() {
      closeDot(true);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', onDotClick);
    });

    WH.all('[data-wh-look-x]', root).forEach(function (btn) {
      btn.addEventListener('click', onCloseClick);
    });

    /* Close on outside click and Escape */
    function onDocClick(e) {
      if (!openDot) return;
      var t = e.target;
      if (up(t, '[data-wh-look-dot]') === openDot) return;
      if (root.contains(t) && up(t, '.wh-look__bubble')) return;
      closeDot(false);
    }

    function onDocKey(e) {
      if (!openDot || (e.key !== 'Escape' && e.key !== 'Esc')) return;
      closeDot(root.contains(document.activeElement));
    }

    document.addEventListener('click', onDocClick);
    document.addEventListener('keydown', onDocKey);

    /* Cross-hover: board or dot <-> list row (mouse), keyboard focus on rows */
    function onEnter(e) {
      if (!openDot) highlight(e.currentTarget.getAttribute('data-wh-look-key'));
    }

    function onLeave() {
      if (!openDot) highlight(null);
    }

    if (canHover) {
      keyed.forEach(function (el) {
        el.addEventListener('mouseenter', onEnter);
        el.addEventListener('mouseleave', onLeave);
      });
    }

    WH.all('.wh-look__row[data-wh-look-key]', root).forEach(function (row) {
      row.addEventListener('focusin', function () {
        if (!openDot) highlight(row.getAttribute('data-wh-look-key'));
      });
      row.addEventListener('focusout', function (e) {
        if (!openDot && !row.contains(e.relatedTarget)) highlight(null);
      });
    });

    /* wise.js resets the button text after an add: we restore our label */
    if ('MutationObserver' in window) {
      WH.all('[data-quick-open]', root).forEach(function (btn) {
        var html = btn.innerHTML;
        var label = norm(btn.textContent);
        if (label === 'Ajouter au panier' || label === 'Add to basket') return;
        var mo = new window.MutationObserver(function () {
          var t = norm(btn.textContent);
          if (t === 'Ajouter au panier' || t === 'Add to basket') btn.innerHTML = html;
        });
        mo.observe(btn, { childList: true, characterData: true, subtree: true });
        observers.push(mo);
      });
    }

    /* Section reloaded in editor: wise.js doesn't rebind new buttons, simple fallback */
    if (fromEditor) {
      WH.all('[data-card-quick]', root).forEach(function (wrap) {
        var opener = wrap.querySelector('[data-quick-open]');
        var panel = wrap.querySelector('[data-quick-panel]');
        var closer = wrap.querySelector('[data-quick-close]');
        if (!opener || !panel) return;
        opener.addEventListener('click', function () {
          var willOpen = panel.hidden;
          panel.hidden = !willOpen;
          opener.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        });
        if (closer) {
          closer.addEventListener('click', function () {
            panel.hidden = true;
            opener.setAttribute('aria-expanded', 'false');
            focusEl(opener);
          });
        }
        WH.all('[data-quick-variant]', panel).forEach(function (btn) {
          btn.addEventListener('click', function () {
            var id = btn.getAttribute('data-quick-variant');
            if (!id || btn.disabled) return;
            var routes = window.WiseRoutes || {};
            window.location.href = (routes.cartAdd || '/cart/add') + '?id=' + encodeURIComponent(id) + '&quantity=1';
          });
        });
      });
    }

    root.__whLook = {
      select: function (key) {
        closeDot(false);
        if (key === null || key === undefined || key === '') {
          highlight(null);
          return;
        }
        for (var i = 0; i < dots.length; i++) {
          if (dots[i].getAttribute('data-wh-look-key') === key) {
            setDot(dots[i], true);
            return;
          }
        }
        highlight(key);
      },
      destroy: function () {
        document.removeEventListener('click', onDocClick);
        document.removeEventListener('keydown', onDocKey);
        observers.forEach(function (mo) {
          mo.disconnect();
        });
        root.__whLook = null;
      }
    };
  }

  /* ================= Startup, theme editor ================= */
  WH.ready(function (scope) {
    var fromEditor = scope !== document;
    WH.all('[data-wh-ugc]', scope).forEach(function (root) {
      initUgc(root);
    });
    WH.all('[data-wh-look]', scope).forEach(function (root) {
      initLook(root, fromEditor);
    });
  });

  WH.unload(function (section) {
    WH.all('[data-wh-ugc]', section).forEach(function (root) {
      if (root.__whUgc) root.__whUgc.destroy();
    });
    WH.all('[data-wh-look]', section).forEach(function (root) {
      if (root.__whLook) root.__whLook.destroy();
    });
  });

  /* \"Piece\" block selected: opens its dot (or highlights its row) */
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    var root = up(el, '[data-wh-look]');
    if (!root || !root.__whLook) return;
    root.__whLook.select(el.getAttribute('data-wh-look-key'));
  });

  document.addEventListener('shopify:block:deselect', function (e) {
    var root = up(e.target, '[data-wh-look]');
    if (root && root.__whLook) root.__whLook.select(null);
  });
})();
